import { Navigate } from "react-router-dom";
import useLangStore from "@/hooks/useLangStore";
import useAuthStore from "@/hooks/useAuthStore";
import LoginScreen from "@/UI/screens/LoginScreen";

export default function LoginRoute() {
    const { lang } = useLangStore();
    const { token } = useAuthStore();
    if (!lang) return <Navigate to="/choose-lang" replace />;
    if (token) return <Navigate to="/select-store" replace />;
    return <LoginScreen />;
}
